document.addEventListener("DOMContentLoaded", function () {
	const $slider = $(".project-highlights__slider");
	if (!$slider.length) return;

	const mobileBreakpoint = 1024;
	let slickActive = false;

	function initMobileSlider() {
		if (window.innerWidth < mobileBreakpoint && !slickActive) {
			$slider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				infinite: true,
				speed: 400,
				prevArrow: $slider
					.closest(".project-highlights")
					.find(".project-highlights__prev"),
				nextArrow: $slider
					.closest(".project-highlights")
					.find(".project-highlights__next"),
				swipe: true,
				touchMove: true,
			});
			slickActive = true;
		} else if (window.innerWidth >= mobileBreakpoint && slickActive) {
			$slider.slick("unslick");
			slickActive = false;
		}
	}

	initMobileSlider();
	window.addEventListener("resize", initMobileSlider);
});
